// extracted by mini-css-extract-plugin
module.exports = {"__next":"video_meta___next__XeTek","meta":"video_meta_meta__JIp2e","author":"video_meta_author__Rbk_W","dot":"video_meta_dot__Nj16j"};